
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"currentColor"}},[_c('path',{attrs:{"d":"M11.818 1.38c.41 0 .737.128.979.385s.363.598.363 1.023v12.914c0 .425-.125.77-.374 1.034-.25.264-.572.396-.968.396-.47 0-.829-.169-1.078-.506L2.71 6.176v9.526c0 .425-.117.77-.352 1.034s-.557.396-.968.396c-.41 0-.733-.132-.968-.396S.07 16.127.07 15.702V2.788c0-.425.125-.766.374-1.023.25-.257.58-.385.99-.385.455 0 .807.169 1.056.506l8.008 10.406V2.788c0-.425.121-.766.363-1.023.242-.257.561-.385.957-.385zm4.95 16.368c-.088.279-.227.484-.418.616-.19.132-.403.198-.638.198-.293 0-.554-.099-.781-.297a.961.961 0 01-.341-.759c0-.132.022-.264.066-.396L19.76 1.116c.088-.279.227-.484.418-.616.19-.132.403-.198.638-.198.293 0 .554.099.781.297a.961.961 0 01.341.759c0 .132-.022.264-.066.396l-5.104 15.994zM29.44 1.358c.308 0 .598.077.869.231.271.154.473.378.605.671l6.094 13.046c.088.19.132.381.132.572 0 .337-.136.623-.407.858a1.388 1.388 0 01-.935.352 1.25 1.25 0 01-.66-.187 1.248 1.248 0 01-.484-.583l-1.32-2.948H25.59l-1.32 2.948a1.248 1.248 0 01-.484.583 1.289 1.289 0 01-.682.187c-.337 0-.645-.117-.924-.352s-.418-.52-.418-.858c0-.19.044-.381.132-.572L27.966 2.26a1.42 1.42 0 01.605-.671c.271-.154.561-.231.869-.231zm.022 3.278l-2.904 6.534h5.808l-2.904-6.534z"}})])])
          )
        }
      }
    